import type { LockCalculatorFormValues } from "./form";

export type StructuralVisibility = {
  showUpliftResistanceConfig: boolean;
};

/**
 * A load field counts as "set" only when it's a real, non-zero value — an
 * explicit 0 means the same as leaving it empty (no load on that axis), not
 * "activate this axis's verification". Shared with CombinedVerificationForm's
 * toggle-enablement so the two can't drift onto different rules for the same
 * question ("does this axis have a real load?").
 */
export const hasRealLoadValue = (value: number | null | undefined): boolean => value != null && value !== 0;

/**
 * Single source of truth for which Structure-step fields are relevant given
 * the loads entered in the Loads step (the lateral resistance is always shown: without a lateral load it
 * says where the connection sits). Consumed by StructureStep — if the
 * rule changes, this is the only place to update.
 */
export const getStructuralVisibility = (loads: LockCalculatorFormValues["loads"]): StructuralVisibility => ({
  showUpliftResistanceConfig: hasRealLoadValue(loads.uplift),
});
